import { render, staticRenderFns } from "./InputClientToken.vue?vue&type=template&id=6b587144"
import script from "./InputClientToken.vue?vue&type=script&lang=js"
export * from "./InputClientToken.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports